import Axios from "axios";

export const getAllClaimReconciliationList = (
  obj,
  page = 1,
  search = "",
  status = "",
  startDate,
  endDate,
) => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/claim-utilization-reports?page=${page}&search=${search}&status=${status}&from_date=${startDate}&to_date=${endDate}`,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  ).then((res) => {
    return res.data;
  });
};

export const deleteReports = (id, obj) => {
  return Axios.delete(
    process.env.REACT_APP_NOT_SECRET_CODE + "/claim-utilization-reports/" + id,
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateStatusChange = (obj, status, ids) => {
  return Axios.put(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/claim-utilization-reports-update`,
    { status, ids },
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};